import CustomPrismicLink from '@monofront/design-system/prismic-link/CustomPrismicLink/CustomPrismicLink';
import { IPrismicRichText, PrismicLinkContext } from '@monofront/types';
import { RichText } from 'prismic-reactjs';

interface ISmallCenteredTextProps {
  text: IPrismicRichText;
}

const SmallCenteredText: React.FC<ISmallCenteredTextProps> = ({ text }) => {
  return (
    <>
      <div className="small-centered-text">
        <RichText
          render={text}
          serializeHyperlink={CustomPrismicLink(
            PrismicLinkContext.SHOP,
            'tw-lf-link-inherit',
          )}
        />
      </div>

      <style jsx>{`
        .small-centered-text {
          text-align: center;
          margin: var(--space-6) 0;
        }

        .small-centered-text :global(p) {
          font-size: var(--font-size-1);
        }
      `}</style>
    </>
  );
};

export default SmallCenteredText;
